"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LogContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _clevertap = require("../utils/clevertap");

var _excluded = ["children", "logImpression"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Context = /*#__PURE__*/_react["default"].createContext('');

var LogContext = Context;
exports.LogContext = LogContext;

var Log = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Log, _React$PureComponent);

  var _super = _createSuper(Log);

  function Log(props) {
    var _this;

    _classCallCheck(this, Log);

    _this = _super.call(this, props);
    _this.state = {
      isInViewport: false
    };
    _this.hasImpressionAlreadyBeenLogged = false;
    _this.observerCallback = _this.observerCallback.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Log, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.logImpression) {
        this.setupObserver();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.logImpression && this.state.isInViewport && !this.hasImpressionAlreadyBeenLogged) {
        var _this$props$logEventP;

        (0, _clevertap.event)((_this$props$logEventP = this.props.logEventProps) === null || _this$props$logEventP === void 0 ? void 0 : _this$props$logEventP.eventName, _objectSpread({}, this.props.logEventProps));
        this.hasImpressionAlreadyBeenLogged = true;
      }
    }
  }, {
    key: "setupObserver",
    value: function setupObserver() {
      this.observer = new IntersectionObserver(this.observerCallback, {
        root: null,
        rootMargin: '0px',
        threshold: this.props.threshold || 0.01
      });
      var trackElement = document.getElementById(this.props.id); // const wrappedDOMElements = this.logDOMElementRef?.current?.childNodes;
      // const firstVisibleElement = find(wrappedDOMElements, (el) => el.offsetParent !== null);

      if (trackElement) {
        this.observer.observe(trackElement);
      }
    }
  }, {
    key: "observerCallback",
    value: function observerCallback(entries) {
      var entry = entries === null || entries === void 0 ? void 0 : entries[0];

      if (entry !== undefined && this.state.isInViewport !== entry.isIntersecting) {
        this.setState(function () {
          return {
            isInViewport: entry.isIntersecting
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          logImpression = _this$props.logImpression,
          directProps = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/_react["default"].createElement(LogContext.Consumer, null, function (consumedProps) {
        var combinedProps = _objectSpread(_objectSpread({}, consumedProps), directProps);

        return /*#__PURE__*/_react["default"].createElement(LogContext.Provider, {
          value: combinedProps
        }, children);
      });
    }
  }]);

  return Log;
}(_react["default"].PureComponent);

exports["default"] = Log;